import Vue from 'vue';
import Vuetify from 'vuetify';
import '@/sass/overrides.sass';

Vue.use(Vuetify);

const OCG_CI = {
  primary: '#2b3643',
  accent: '#364150',
  secondary: '#5C7CA1',
  success: '#71BC78',
  info: '#364150',
  warning: '#FAA46A',
  error: '#C01212',
};

export default new Vuetify({
  theme: {
    themes: {
      dark: OCG_CI,
      light: OCG_CI,
    },
  },
});
